import { useTranslation } from 'react-i18next';
import { ControlledMultiPickerWithCategory } from 'src/shared/components/form/controlledMultiPickerWithCategory';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import useDistrictPickerHeader from 'src/shared/hooks/useDistrictPickerHeader';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { District } from 'src/shared/models/district/district';
import { getDistricts } from 'src/shared/services/districtService';

type ControlledMultiDistrictPickerProps = {
  name: string;
  callback?: (x: District[] | undefined) => void;
};

export const ControlledMultiDistrictPicker = (props: ControlledMultiDistrictPickerProps) => {
  const { callback = undefined, name } = props;
  const { t } = useTranslation(['common']);
  const isMounted = useIsMounted();
  const { pickerHeader, userHasDistrict } = useDistrictPickerHeader();

  return (
    <ControlledMultiPickerWithCategory<District>
      name={name}
      limitTags={2}
      componentWidth='100%'
      callback={(x) => {
        if (callback) {
          callback(x);
        }
      }}
      showCategory={userHasDistrict}
      fetchMethod={async () => {
        try {
          const result = await getDistricts(0, 10000, 'countyAss', 'asc', true);
          if (isMounted()) {
            ConsoleHelper.log('result', result);
            const countyArray: any = [];
            result.data.results
              .sort((a, b) => (a.parentCode > b.parentCode ? 0 : -1))
              .forEach((district) => {
                if (userHasDistrict) {
                  // Pushar in options för "Hela kategorin" som ska välja alla kompetenser inom samma kategori
                  countyArray.push({
                    code: district.countyAss_id,
                    parentName: district.countyAss,
                    parentCode: district.countyAss_id,
                    isParent: true,
                    name: t('common:form.districtPickerAll', { region: district.countyAss }),
                  });
                }

                if (district && district.associations) {
                  district.associations.forEach((ass) => {
                    // Pushar in alla associations
                    countyArray.push({
                      code: ass.localAss_id,
                      parentName: district.countyAss,
                      parentCode: district.countyAss_id,
                      isParent: false,
                      name: ass.localAss,
                    });
                  });
                }
              });
            ConsoleHelper.log('countyArray', countyArray);
            return countyArray;
          }
        } catch (e) {
          if (isMounted()) {
            ConsoleHelper.log(e);
          }
        }

        return [];
      }}
      label={pickerHeader}
    />
  );
};
